export function formatPrice(price) {
    return new Intl.NumberFormat('nb-NO', {
        style: 'currency',
        currency: 'NOK'
    }).format(price);
}